import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { InputSwitch } from 'primereact/inputswitch';
import { Fieldset } from 'primereact/fieldset';
import { Toolbar } from 'primereact/toolbar';

import prefixNoService from './prefixno-service';
import BreadcrumbComponent from '../../../../components/Breadcrumb';

interface AutoNoFormProps { }
interface DropdownItem {
    referenceName: string;
    referenceCode: string;
    fullDesc: string;
}

const PrefixnoEdit: React.FC<AutoNoFormProps> = () => {

    const [clientState, setClientState] = useState<any>(null);
    const [selectedNodeJson, setSelectedNodeJson] = useState<any>(null);
    const [moduleDropdown, setModuleDropdown] = useState<DropdownItem[]>([]);
    const [tableDropdown, setTableDropdown] = useState<DropdownItem[]>([]);
    const navigate = useNavigate();
    const location = useLocation();

    const [modprefixno, setModprefixno] = useState<any>({});
    const modprefixnoItem = location.state?.selectItem;
    const isEditMode = !!modprefixnoItem;

    const [inputNumberValue, setInputNumberValue] = useState<number | null>(
        null
    );
    const [radioValue, setRadioValue] = useState(null);
    const toast = useRef<Toast>(null);
    const [modules, setModules] = useState<any[]>([]);
    const [tables, setTables] = useState<any[]>([]);
    const [prefixOptions] = useState([
        { fullDesc: '@YYYY', code: '@YYYY' },
        { fullDesc: '@YY', code: '@YY' },
        { fullDesc: '@YYYYMM', code: '@YYYYMM' },
        { fullDesc: '@YYMM', code: '@YYMM' }
    ]);

    const moduleDropdownOptions = useMemo(() => moduleDropdown, [moduleDropdown]);
    const tableDropdownOptions = useMemo(() => tableDropdown, [tableDropdown]);
    const defaultData = {
        indent: null,
        lastNo: null,
        increment: null,
    }
    useEffect(() => {
        const fetchClientState = async () => {
            try {
                prefixNoService.getClientState().then((data) => {
                    setClientState(data);
                });

                prefixNoService.getModuleDropdown().then((data) => {
                    setModuleDropdown(data);
                });

                prefixNoService.getTableDropdown().then((data) => {
                    setTableDropdown(data);
                });

                if (isEditMode) {
                    prefixNoService.getItemById(modprefixnoItem.moduleId, modprefixnoItem.documentType).then((data) => {
                        if (data != null) {
                            setModprefixno(modprefixnoItem);
                            setRadioValue(modprefixnoItem.generateType);
                        }
                    });
                } else {
                    setModprefixno(defaultData);

                };
            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };
        fetchClientState();
    }, []);

    const handleSave = () => {
        const currentDate = new Date().toLocaleString("en-US", { timeZone: clientState.timeZone });
        if (isEditMode) {
            modprefixno.modifiedBy = clientState.fullName;
            modprefixno.modifiedDate = new Date(currentDate);
            prefixNoService.update(modprefixno.moduleId, modprefixno.documentType, modprefixno).then(async () => {
                await new Promise((resolve) => setTimeout(resolve, 2000));
                alert('Form submitted successfully!');
                navigate('/admin/prefix-no');
            });
        } else {
            modprefixno.insertBy = clientState.fullName;
            modprefixno.insertDate = new Date(currentDate);
            modprefixno.modifiedBy = clientState.fullName;
            modprefixno.modifiedDate = new Date(currentDate);
            modprefixno.facilityCode = clientState.facilityCode;
            prefixNoService.create(modprefixno).then(async () => {
                await new Promise((resolve) => setTimeout(resolve, 2000));
                alert('Form submitted successfully!');

                navigate(`/admin/prefix-no`);
            });
        }
    };

    function handleBack(): void {
        navigate(`/admin/prefix-no`);
    }

    const toolbarTemplate = () => {
        return (
            <>
                <Toast ref={toast} />
                <Button label="Save" icon="pi pi-check" style={{ marginRight: '.5em' }} onClick={() => handleSave()} />
                {/* <Button label="Delete" icon="pi pi-trash" style={{ marginRight: '.5em' }} /> */}
                <Button label="Back" icon="pi pi-times" style={{ marginRight: '.5em' }} onClick={() => handleBack()} />

            </>
        );
    };

    const handleDropdownChange = (e: any) => {
        const { id, value } = e.target;
        setModprefixno({
            ...modprefixno,
            [id]: value
        });
    };
    const resetSelection = () => {
        prefixNoService.updateList().then(async () => {
            await new Promise((resolve) => setTimeout(resolve, 2000));

            prefixNoService.getTableDropdown().then((data) => {
                setTableDropdown(data);
            });
            alert('List Table successfully Updated!');
        });
    };

    return (
        <div className="grid">
            <div className="col-12">
                {/* Title Section */}
                <div className="card-title">
                    <h5>Prefix No Form</h5>
                    <BreadcrumbComponent />
                </div>

                {/* Form Section */}
                <div className="form-title">
                    <Fieldset legend="Module Information">
                        <div className="p-fluid form-grid grid">
                            {/*
                    Row 1:
                    - Module (left)
                    - Generate Type (center)
                    - Auto No. (right)
                  */}
                            <div className="field col-12 md:col-4">
                                <label htmlFor="moduleId">Module</label>
                                <Dropdown
                                    id="moduleId"
                                    value={modprefixno?.moduleId || ""}
                                    onChange={handleDropdownChange}
                                    options={moduleDropdownOptions}
                                    optionLabel="fullDesc"
                                    optionValue="moduleId"
                                    placeholder="Select One"
                                />
                            </div>

                            {/* Center column: Generate Type */}
                            <div className="field col-12 md:col-4 flex flex-column align-items-center justify-content-center">
                                <label
                                    htmlFor="generateType"
                                    style={{ textAlign: "center", marginBottom: "0.5rem" }}
                                >
                                    Generate Type
                                </label>
                                <div className="flex align-items-center gap-3">
                                    <div className="field-radiobutton">
                                        <RadioButton
                                            inputId="optionMaster"
                                            name="generateType"
                                            value="M"
                                            checked={modprefixno.generateType === "M"}
                                            onChange={(e) =>
                                                setModprefixno({
                                                    ...modprefixno,
                                                    generateType: e.value,
                                                })
                                            }
                                        />
                                        <label htmlFor="optionMaster">Master</label>
                                    </div>
                                    <div className="field-radiobutton">
                                        <RadioButton
                                            inputId="optionFacility"
                                            name="generateType"
                                            value="I"
                                            checked={modprefixno.generateType === "I"}
                                            onChange={(e) =>
                                                setModprefixno({
                                                    ...modprefixno,
                                                    generateType: e.value,
                                                })
                                            }
                                        />
                                        <label htmlFor="optionFacility">Facility</label>
                                    </div>
                                </div>
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="documentType">Table Name</label> <Button
                                    icon="pi pi-refresh"
                                    className="p-button-text"
                                    onClick={resetSelection}
                                    tooltip="Refresh Table List"
                                />
                                <Dropdown
                                    id="tableName"
                                    value={modprefixno?.tableName || ""}
                                    onChange={handleDropdownChange}
                                    options={tableDropdownOptions}
                                    optionLabel="tableName"
                                    optionValue="tableName"
                                    placeholder="Select One"
                                    filter
                                />

                            </div>

                            {/*
                    Row 2:
                    - Prefix 1 (left)
                    - Prefix 2 (right)
                  */}
                            <div className="field col-12 md:col-4">
                                <label htmlFor="documentType">Auto No.</label>
                                <InputText
                                    id="documentType"
                                    value={modprefixno.documentType}
                                    onChange={(e) =>
                                        setModprefixno({
                                            ...modprefixno,
                                            documentType: e.target.value.toUpperCase(),
                                        })
                                    }
                                />
                            </div>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="prefix1">Prefix 1</label>
                                <InputText
                                    id="prefix1"
                                    value={modprefixno.prefix}
                                    onChange={(e) =>
                                        setModprefixno({
                                            ...modprefixno,
                                            prefix: e.target.value,
                                        })
                                    }
                                />
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="prefix2">Prefix 2</label>
                                <Dropdown
                                    id="prefix2"
                                    value={modprefixno.prefix2}
                                    options={prefixOptions}
                                    optionValue="code"
                                    optionLabel="fullDesc"
                                    placeholder="Select Prefix"
                                    onChange={(e) =>
                                        setModprefixno({
                                            ...modprefixno,
                                            prefix2: e.value,
                                        })
                                    }
                                />
                            </div>

                            {/*
                    Row 3:
                    - Indentation
                    - Increment
                    - Last No.
                  */}
                            <div className="field col-12 md:col-4">
                                <label htmlFor="indent">Indentation</label>
                                <InputNumber
                                    inputId="indent"
                                    name="indent"
                                    showButtons
                                    mode="decimal"
                                    value={modprefixno.indent}
                                    onValueChange={(e) =>
                                        setModprefixno({
                                            ...modprefixno,
                                            indent: e.value,
                                        })
                                    }
                                />
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="increment">Increment</label>
                                <InputNumber
                                    inputId="increment"
                                    name="increment"
                                    showButtons
                                    mode="decimal"
                                    value={modprefixno.increment}
                                    onValueChange={(e) =>
                                        setModprefixno({
                                            ...modprefixno,
                                            increment: e.value,
                                        })
                                    }
                                />
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="lastNo">Last No.</label>
                                <InputNumber
                                    inputId="lastNo"
                                    name="lastNo"
                                    showButtons
                                    mode="decimal"
                                    value={modprefixno.lastNo}
                                    onValueChange={(e) =>
                                        setModprefixno({
                                            ...modprefixno,
                                            lastNo: e.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </Fieldset>

                    {/* A bit of spacing before the toolbar */}
                    <div style={{ margin: "1rem 0" }} />

                    {/* Toolbar Section */}
                    <Toolbar end={toolbarTemplate} />
                </div>
            </div>
        </div>
    );

};

export default PrefixnoEdit;
